"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFakeOutlookInstance = exports.getOutlookInstance = exports.initializeOutlookInstance = void 0;
var HxActiveSet_1 = require("./HxActiveSet");
function initializeOutlookInstance(interopBridge) {
    HxActiveSet_1.HxActiveSet.createInstance(interopBridge);
}
exports.initializeOutlookInstance = initializeOutlookInstance;
function getOutlookInstance() {
    return {
        activeSet: HxActiveSet_1.HxActiveSet.Instance,
        actorAPIs: HxActiveSet_1.HxActiveSet.Instance.actorAPIs,
    };
}
exports.getOutlookInstance = getOutlookInstance;
function getFakeOutlookInstance() {
    var fakeActiveSet = HxActiveSet_1.HxActiveSet.getFakeInstance();
    return {
        activeSet: fakeActiveSet,
        actorAPIs: fakeActiveSet.actorAPIs,
    };
}
exports.getFakeOutlookInstance = getFakeOutlookInstance;
